export default {
  namespaced: true,
  state: () => {
    return {
      level: "全部",
    };
  },
  mutations: {
    setMapLevel(state, townName) {
      state.level = townName;
    },

    clearMapLevel(state) {
      // 清除Token
      state.level = "全部";
    },
  },
  actions: {},
};
